import {
    HttpClient,
    HttpErrorResponse,
    HttpHeaders,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, tap } from 'rxjs'
import { environment } from '../../../environments/environment'
import { RequestService } from '../request/request.service'
import { QueryGet } from '../../shared/query-types'
import {
    SocialSecurity,
    SocialSecurityDTO,
} from '../../models/socialsecurity.interface'
import { Pagination } from '../../models/pagination.interface'
import { AsyncFormValidation } from '../../interceptors/error.interceptor'

@Injectable({
    providedIn: 'root',
})
export class SocialsecurityService {
    httpOptions = {
        headers: new HttpHeaders({}),
    }
    private apiUrl = environment.service_1 + 'social-security/'
    private socialsecurities = new BehaviorSubject<SocialSecurity[]>([])
    socialsecurities$ = this.socialsecurities.asObservable()

    private socialsecuritiesSelected =
        new BehaviorSubject<SocialSecurity | null>(null)
    $socialsecuritiesSelected = this.socialsecuritiesSelected.asObservable()

    private asyncErrorValidation =
        new BehaviorSubject<AsyncFormValidation | null>(null)
    asyncErrorValidation$ = this.asyncErrorValidation.asObservable()

    constructor(
        private requestService: RequestService,
        private http: HttpClient
    ) {}

    setSocialSecurities(socialsecurities: SocialSecurity[]) {
        this.socialsecurities.next(socialsecurities)
    }

    setSocialSecurity(socialSecurity: SocialSecurity) {
        this.socialsecuritiesSelected.next(socialSecurity)
    }

    allSocialSecurity(): Observable<SocialSecurity[]> {
        return this.http.get<SocialSecurity[]>(this.apiUrl, {
            headers: this.httpOptions.headers,
        })
    }

    allSocialSecurities(
        queryParams: QueryGet
    ): Observable<Pagination<SocialSecurity[]>> {
        return this.requestService.get<SocialSecurity[]>(
            this.apiUrl,
            queryParams
        )
    }

    deleteSocialSecurity(id: number): Observable<void> {
        return this.http.delete<void>(this.apiUrl + id + '/')
    }

    updateSocialSecurity(
        id: number,
        socialSecurity: SocialSecurityDTO & { id: number }
    ) {
        return this.http
            .put<SocialSecurity>(this.apiUrl + id + '/', socialSecurity)
            .pipe(
                tap({
                    error: (err: HttpErrorResponse) => {
                        this.asyncErrorValidation.next(err.error)
                    },
                })
            )
    }
}
